
import React from 'react'
import './responsedisplay.css'
import {ExpandLess, ExpandMore } from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import CopilotContext from '../../../contexts/CopilotContext'

import {ResponseDisplay} from "../responsedisplay/ResponseDisplay"
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';

import { ArrowForwardIconGray } from '../customicons/ArrowForwardIconGray'

export const ResponseDisplayWithQuestions = ({ displayprompt, displayicons, changeConfirmDelete, onDeletePrompt, onSubmitQuestion , onResubmitChat, onClickRelated, onCopy }) => {
  let {
    isLoading,
    changeLanguage,
    } = React.useContext(StatusContext); 

    let {
     displayrelated,
     
    } = React.useContext(CopilotContext);
  
  return (
    <div disabled={isLoading} >
      {
        <div key={displayprompt.id}>
         
        
         <ResponseDisplay  displayprompt = {displayprompt} 
                            displayicons = {displayicons}
                            changeConfirmDelete = {changeConfirmDelete}
                            onDeletePrompt = {onDeletePrompt}
                            onResubmitQuestion = {onResubmitChat}
                            onCopy={onCopy}
                            />
         
          {displayprompt.response && (
          <>
           
            <div className="promptTextRelated" onClick={() => {!isLoading && onClickRelated()}}>
              {
              (displayrelated) ?
                <ExpandLess className="promptIcon1" />
              :
                <ExpandMore className="promptIcon1" />
              }
              {changeLanguage('assistant', 'related')}              
            </div>
            <>
            {
            (displayrelated) &&
            <>
           
              {
                (displayprompt.question_1) && 
                <div className='flex-container-top'  style = {{color:'maroon', fontWeight:'500', fontSize:'12px'}}>
                  <ArrowForwardIconGray onClick={() => {!isLoading && onSubmitQuestion(displayprompt.question_1)}} />
                  <MarkdownResponseDisplay  text={displayprompt.question_1} paragraphcolor={'maroon'}/>  
                </div>
            }
            {
              (displayprompt.question_2) && 
                <div className='flex-container-top' style = {{color:'maroon', fontWeight:'500'}}>
                  <ArrowForwardIconGray onClick={() => {!isLoading && onSubmitQuestion(displayprompt.question_2)}} />
                  <MarkdownResponseDisplay  text={displayprompt.question_2} paragraphcolor={'maroon'}/>  
              </div>
            }
            {
              (displayprompt.question_3) && 
                <div className='flex-container-top' style = {{color:'maroon', fontWeight:'500'}}>
                  <ArrowForwardIconGray onClick={() => {!isLoading && onSubmitQuestion(displayprompt.question_3)}} />
                  <MarkdownResponseDisplay  text={displayprompt.question_3} paragraphcolor={'maroon'}/>  
                </div>
            }
            {
              (displayprompt.question_4) && 
                <div className='flex-container-top' style = {{color:'maroon', fontWeight:'500'}}>
                  <ArrowForwardIconGray onClick={() => {!isLoading && onSubmitQuestion(displayprompt.question_4)}} />
                  <MarkdownResponseDisplay  text={displayprompt.question_4} paragraphcolor={'maroon'}/>  
                </div>
            }
            {
              (displayprompt.question_5) && 
                <div className='flex-container-top' style = {{color:'maroon', fontWeight:'500'}}>
                  <ArrowForwardIconGray onClick={() => {!isLoading && onSubmitQuestion(displayprompt.question_5)}} />
                  <MarkdownResponseDisplay  text={displayprompt.question_5} paragraphcolor={'maroon'}/>  
                </div>
            }
         
            </>
            }       
            <hr style={{color:'rgb(30, 142, 142)'}}></hr>
            </>
           
         </>
        )}
        </div>
      }
    </div>
  )
}


ResponseDisplayWithQuestions.defaultProps = {
  showprompts: true
};

export default ResponseDisplayWithQuestions
